module.exports = __webpack_public_path__ + "static/media/show.2686acbb.svg";